import { useFeatureFlags } from '@brightdrop/feature-flags-client';
import { cx } from '@emotion/css';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConnectedByOnStarTextSvg from '~/assets/icons/new/ConnectedByOnStarText.svg?react';
import OnStarIconSvg from '~/assets/icons/new/OnStar.svg?react';
import { ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG } from '~/common/models/featureFlags.model';
import useOnStarNavRibbonStyles from './OnStarNavRibbon.styles';

export type OnStarNavRibbonProps = {
  isNavDrawerOpen: boolean;
};

/**
 * LHN-bottom OnStar ribbon for lg+ viewports. Icon-only when the drawer is collapsed;
 * full label when expanded.
 */
const OnStarNavRibbon = ({
  isNavDrawerOpen,
}: OnStarNavRibbonProps): JSX.Element | null => {
  const { getFlag } = useFeatureFlags();
  const { classes } = useOnStarNavRibbonStyles();
  const { t } = useTranslation();
  const isOnStarIntelligenceRebrandEnabled = Boolean(
    getFlag(ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG)
  );

  if (isOnStarIntelligenceRebrandEnabled) {
    return null;
  }

  const ariaLabel = t('common:onStarRibbon.connectedByOnStarAriaLabel');

  return (
    <Box
      className={cx(classes.root, { isOpen: isNavDrawerOpen })}
      data-testid="onstar-nav-ribbon"
      aria-label={isNavDrawerOpen ? undefined : ariaLabel}
      role={isNavDrawerOpen ? undefined : 'img'}
    >
      {!isNavDrawerOpen && (
        <Box className={classes.iconWrapper}>
          <OnStarIconSvg aria-hidden />
        </Box>
      )}
      {isNavDrawerOpen && (
        <ConnectedByOnStarTextSvg
          role="img"
          aria-label={ariaLabel}
          data-testid="onstar-nav-ribbon-label"
        />
      )}
    </Box>
  );
};

export default OnStarNavRibbon;
